import { useEffect } from "react";

export default function useLoadOnInteraction(callback: () => void) {
  useEffect(() => {
    let triggered = false;

    const trigger = () => {
      if (triggered) return;
      triggered = true;

      callback();

      window.removeEventListener("scroll", trigger);
      window.removeEventListener("mousemove", trigger);
      window.removeEventListener("touchstart", trigger);
      window.removeEventListener("click", trigger);
    };

    window.addEventListener("scroll", trigger, { once: true });
    window.addEventListener("mousemove", trigger, { once: true });
    window.addEventListener("touchstart", trigger, { once: true });
    window.addEventListener("click", trigger, { once: true });

    return () => {
      window.removeEventListener("scroll", trigger);
      window.removeEventListener("mousemove", trigger);
      window.removeEventListener("touchstart", trigger);
      window.removeEventListener("click", trigger);
    };
  }, []);
}